import { render, staticRenderFns } from "./CaseBupa.vue?vue&type=template&id=ec1ce0d6"
import script from "./CaseBupa.vue?vue&type=script&lang=js"
export * from "./CaseBupa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports